import React from "react";
import useWithStore from "@/Hooks/useWithStore";
import YourChoiceLayout from "@/Layouts/YourChoiceLayout";
import classNames from "classnames";

const SelectedFilters = (props) => {
    const {stores = {}, selectedFilters = []} = props;
    const {catalogStore = {}} = stores;

    const chipsClassName = classNames('chips', props.className, {});

    const resetAllFilters = () => {
        catalogStore.resetAllFilters();
    };

    return <div className={chipsClassName}>
        {selectedFilters.map((selectedFilter, index) => {
            return <YourChoiceLayout key={index}
                                     value={selectedFilter.value}
                                     onClick={() => catalogStore.deleteFilter(selectedFilter)}
            />
        })}
        {selectedFilters.length > 1 && (
            <YourChoiceLayout value={`Очистить все`} onClick={resetAllFilters} />
        )}
    </div>
};

export default useWithStore(SelectedFilters);
